import { useState } from 'react';
import { useI18n } from '../i18n';
import ShareModal from './ShareModal';
import { buildReportText, encodeModes } from '../lib/share';
import { makeReportImage } from '../lib/shareImage';
import { IconShare } from './Icons';
import type { Lang } from '../lib/countries';

const SITE = 'https://geodle.org';

// 首页「今日整体战报」分享入口(不剧透)—— dle-best-practice §7.1
export default function ReportShare({
  num,
  solved,
  streak,
  lang,
}: {
  num: number;
  solved: string[];
  streak: number;
  lang: Lang;
}) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  const url = SITE + '/';
  const text = buildReportText(num, solved, streak);
  const modes = encodeModes(solved);
  const embed = `<a href="${url}"><img src="${SITE}/api/og?type=report&num=${num}&modes=${modes}&streak=${streak}&lang=${lang}" alt="GeoDle #${num} today" width="600" height="315"></a>`;

  return (
    <>
      <button className="ds-share" onClick={() => setOpen(true)} aria-label={t.shareToday} title={t.shareToday}>
        <IconShare />
      </button>
      {open && (
        <ShareModal
          title={t.shareToday}
          text={text}
          url={url}
          embed={embed}
          makeImage={() => makeReportImage({ num, solved, streak, lang })}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
